export const DEFAULT_PAGINATION = { page: 1, limit: 1000 } as const;
